import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common';

@Injectable()
export class OnesignalProvider {

  constructor(public http: HttpClient, private commonService: CommonProvider) {}

  private _url: string = `${this.commonService.apiUrl}api/v1/onesignal`;
  
  storePlayerId(player_id): Observable<Response<any[]>> {
    return this.http.post<Response<any[]>>(this._url + '/store', {player_id : player_id});
  }

}






// WEBPACK FOOTER //
// ./src/providers/onesignal/onesignal.ts